import { Table } from "@/features/Table";
import { type Company, companies_columns } from "./columns";
import { type FilterCompaniesSchema, FilterCompanies } from "./filter";
import { useLocation } from "react-router-dom";

const client = "instit-quantilia";
const table_name = "companies";

export const CompaniesTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<Company, FilterCompaniesSchema>
      label="Companies"
      client={client}
      table_name={table_name}
      columns={companies_columns}
      filter={<FilterCompanies />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
